module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Medium.e36657ad.woff";